import {Component, TemplateRef} from '@angular/core';

import { ToastService } from '../../services/toast.service';


@Component({
  selector: 'app-toasts',
  styleUrls: ['./toast.component.scss'],
  template: `
  <ngb-toast
  *ngFor="let toast of toastService.toasts"
  [header]="toast.headerText"
  [class]="toast.classname"
  [autohide]="toast.autohide"
  [delay]="toast.delay || 5000"
  (hide)="toastService.remove(toast)"
>
  <div class="toast-body">
  <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  </ng-template>
  
   <ng-template #text>
    <span class="material-icons material-icons-outlined float-left" style="margin-right: 10px;">
       {{ toastService.iconName }}
    </span>
     {{ toast.textOrTpl }}
  </ng-template>
  </div>


</ngb-toast>
  `,
  host: {'[class.ngb-toasts]': 'true'}
})
export class ToastsContainer {
  public autohide = true;
  constructor(public toastService: ToastService) {}

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
